import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import isEmpty from "../../../utils/helpers";
import {hideModal} from '../../../actions/modal.actions';
import DatePicker from "react-datepicker";
import moment from "moment";
import Loader from "../../../components/Loader";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";
import 'src/resources/styles/components/_cmv--datepicker.scss'
import {Formik} from "formik";
import {
    getOrderAvailability, getTroubleTicketAvailability,
    getOrderAppointments, getTroubleTicketAppointments,
    emptyOrderAppointments, emptyTroubleTicketAppointments,
    createOrderAppointment, createTroubleTicketAppointment,
    clearOrderAvailability, clearTroubleTicketAvailability
} from "../../../actions/technicianAppointment.actions";
import {
    getOrderTimeslots,
    getTroubleTicketTimeslots
} from "../../../actions/appointments.actions";
import {
    createLoadingSelector,
    getTechnicianAppointment,
    getModalData,
    getUserPermission, getTimeslots
} from '../../../selectors';
import {toastr} from "react-redux-toastr";


class TechnicianAppointmentModal extends Component {

    state = {
        isOverbookAllowed: false,
        selectedDate: undefined,
        appointmentDate: undefined,
        includedDates: undefined,
        includedTimes: undefined,
    };

    componentDidMount() {
        const {
            getOrderAvailability,
            getTroubleTicketAvailability,
            getOrderAppointments,
            getTroubleTicketAppointments,
        } = this.props;

        const {
            appointment_type,
            id
        } = this.props.modalProps;

        switch (appointment_type) {
            case "TROUBLE_TICKET":
                getTroubleTicketAvailability(id);
                getTroubleTicketAppointments(id);
                this.props.getTroubleTicketTimeslots();
                break;
            case "ORDER":
                getOrderAvailability(id);
                getOrderAppointments(id);
                this.props.getOrderTimeslots();
                break;
        }
    }

    componentDidUpdate(prevProps) {
        const {
            appointmentsLoading,
            technicianAppointments,
            availabilityLoading,
            technicianAvailability,
            geocodeError
        } = this.props;

        if (!appointmentsLoading && !availabilityLoading && !isEmpty(technicianAppointments) && this.state.appointmentDate === undefined) {
            this.getAppointment();
            if(geocodeError != undefined){
                toastr.error(geocodeError, {timeOut: 0, position: 'top-center'});
            }
        }

        if (!appointmentsLoading && !availabilityLoading && !isEmpty(technicianAvailability) && this.state.includedDates === undefined) {
            this.getIncludedDates();
        }
    }

    componentWillUnmount() {
        const { emptyOrderAppointments, emptyTroubleTicketAppointments, clearOrderAvailability, clearTroubleTicketAvailability } = this.props;
        const { appointment_type } = this.props.modalProps;

        switch (appointment_type) {
            case "TROUBLE_TICKET":
                emptyTroubleTicketAppointments();
                clearTroubleTicketAvailability();
                break;
            case "ORDER":
                emptyOrderAppointments();
                clearOrderAvailability();
                break;
        }
    }

    getAppointment = () => {
        let appointments;

        if (this.props.modalProps.appointment_type === "TROUBLE_TICKET") {
            appointments = this.props.technicianAppointments.troubleTicketAppointments;
        }
        else {
            appointments = this.props.technicianAppointments.orderAppointments;
        }

        let appointment = null;

        if (appointments && appointments.length > 0) {
            const formattedDateTime = moment().year(appointments[0].date.year).dayOfYear(appointments[0].date.dayOfYear).format("YYYY-MM-DD") + 'T' + appointments[0].timeslot.fromTime;

            appointment = moment(formattedDateTime).toDate();
        }

        this.setState({
            appointmentDate: appointment,
            selectedDate: appointment,
        }, () => {
            this.getIncludedTimes();
        });
    }

    getIncludedDates = () => {
        const {isOverbookAllowed} = this.state;

        let includedDates = [];
        let filteredIncludedDates = [];

        if (isOverbookAllowed) {

            // Show all future dates including today
            filteredIncludedDates = null;
        }
        else {


            //Add currently scheduled date to appointment
            //Order
            if(this.props.technicianAppointments.orderAppointments != undefined){
                this.props.technicianAppointments.orderAppointments.map((scheduledDate) => {
                    if(scheduledDate.date.dayOfMonth && scheduledDate.date.monthValue && scheduledDate.date.year){
                        let appointmentDate = scheduledDate.date.year + "-" + scheduledDate.date.monthValue + "-" + scheduledDate.date.dayOfMonth
                        if(scheduledDate.timeslot != undefined){
                            if(this.props.technicianAvailability[appointmentDate] != undefined){
                                this.props.technicianAvailability[appointmentDate].map((time, index) => {
                                    if(time.fromTime == scheduledDate.timeslot.fromTime + ":00" &&
                                    time.toTime == scheduledDate.timeslot.toTime  + ":00"){
                                        time.availability += 1
                                    }
                                })
                            }
                        }
                    }
                })
            }

            //Trouble ticket
            if(this.props.technicianAppointments.troubleTicketAppointments != undefined){
                this.props.technicianAppointments.troubleTicketAppointments.map((scheduledDate) => {
                    if(scheduledDate.date.dayOfMonth && scheduledDate.date.monthValue && scheduledDate.date.year){
                        let appointmentDate = scheduledDate.date.year + "-" + scheduledDate.date.monthValue + "-" + scheduledDate.date.dayOfMonth
                        if(scheduledDate.timeslot != undefined){
                            if(this.props.technicianAvailability[appointmentDate] != undefined){
                                this.props.technicianAvailability[appointmentDate].map((time, index) => {
                                    if(time.fromTime == scheduledDate.timeslot.fromTime + ":00" &&
                                        time.toTime == scheduledDate.timeslot.toTime  + ":00"){
                                        time.availability += 1
                                    }
                                })
                            }
                        }
                    }
                })
            }


            // Show dates with availability
            Object.keys(this.props.technicianAvailability).map((date) => {
                includedDates.push(moment(date).toDate())
            });

            //Add already scheduled appointment date

            // Include dates with non-zero availability
            includedDates.map(includedDate => {

                let includeDate = false;

                // If there is availability data for this date
                if (this.props.technicianAvailability[moment(includedDate).format("YYYY-MM-DD")]) {

                    // Get all slots
                    this.props.technicianAvailability[moment(includedDate).format("YYYY-MM-DD")].map(slot => {

                        // Include date if it has some availability
                        if (slot.availability > 0) {

                            // Include today ...
                            if (moment(includedDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {

                                // ... only if it has upcoming availability
                                if (moment.duration(slot.fromTime).asHours() > parseInt(moment().format('H'))) {
                                    includeDate = true;
                                }
                            }

                            // Include all future days
                            else {
                                includeDate = true;
                            }
                        }
                    })
                }

                // Push date
                if (includeDate) {
                    filteredIncludedDates.push(includedDate);
                }
            });
        }

        this.setState({
            includedDates: filteredIncludedDates
        })
    }

    createTimeSlots = (timeSlot) => {
        let time = timeSlot.fromTime.split(":")[0];
        if(time.charAt(0) === '0')
        {
            time = time.substring(1);
        }
        return time;
    }

        getIncludedTimes = () => {
        const {isOverbookAllowed, selectedDate, appointmentDate} = this.state;
        const {troubleTicketTimeslots, orderTimeslots} = this.props;
        const { appointment_type } = this.props.modalProps;

        let includedTimes = [];


        // If overbooking is allowed
        if (isOverbookAllowed) {
            switch (appointment_type) {
                case "TROUBLE_TICKET":
                    troubleTicketTimeslots.map((timeslot) => {
                        includedTimes.push(setHours(setMinutes(setSeconds(new Date(), 0), 0),this.createTimeSlots(timeslot)));
                    });
                    break;
                case "ORDER":
                    // Add all time slots
                    orderTimeslots.map((timeslot) => {
                        includedTimes.push(setHours(setMinutes(setSeconds(new Date(), 0), 0),this.createTimeSlots(timeslot)));
                    });
                    break;
            }
        }
        else {

            // If there is availability for this date
            if (this.props.technicianAvailability[moment(selectedDate).format("YYYY-MM-DD")]) {

                // Get available slots
                this.props.technicianAvailability[moment(selectedDate).format("YYYY-MM-DD")].map(slot => {


                    // Don't add timeslot it if has no availability
                    if (slot.availability <= 0) {
                        return;
                    }

                    // Add timeslot
                    includedTimes.push(setHours(setMinutes(setSeconds(new Date(), 0), 0), moment.duration(slot.fromTime).asHours()));

                });
            }

            // Otherwise if it's not the same as the appointment date
            else if (selectedDate !== appointmentDate) {

                // Deselect the date
                this.setState({selectedDate: undefined});
            }
        }

        this.setState({includedTimes: includedTimes})
    }

    handleDateTimeChange = (newDateTime) => {
        const {troubleTicketTimeslots, orderTimeslots, technicianAvailability} = this.props

        //Gets chosen day technician availability and filters
        let formattedAvailability;
        if(this.state.isOverbookAllowed) {
            if(troubleTicketTimeslots.length) {
                formattedAvailability = troubleTicketTimeslots
            } else {
                formattedAvailability = orderTimeslots
            }
            //We sort availability by earliest fromTime
            formattedAvailability = formattedAvailability.sort((a, b) =>
                parseInt(a.fromTime.slice(0,2)) - parseInt(b.fromTime.slice(0,2))
            )
        } else {
            formattedAvailability = technicianAvailability[moment(newDateTime).format("YYYY-MM-DD")]
                .filter((slot) => slot.availability > 0)
        }

        // If selecting a different day
        if (moment(this.state.selectedDate).format("YYYY-MM-DD") !== moment(newDateTime).format("YYYY-MM-DD") || !this.state.selectedDate) {
            let newDateTimeHrs = parseInt(newDateTime.getHours().toString().substring(0,2))
            let isTimeAvailable = formattedAvailability.filter((availability) => parseInt(availability.fromTime) === newDateTimeHrs)

            if(isTimeAvailable.length) {
                this.setState({
                    selectedDate: setHours(newDateTime, isTimeAvailable[0].fromTime.substring(0,2))
                }, () => {
                    this.getIncludedTimes();
                });
            } else {
                // Reset hours to first time slot
                this.setState({
                    selectedDate: setHours(newDateTime, formattedAvailability[0].fromTime.substring(0,2))
                }, () => {
                    this.getIncludedTimes();
                });
            }
        }
        else {
            this.setState({selectedDate: newDateTime})
        }
    }

    handleOverbookChange = () => {

        this.setState((prevState) => ({
            isOverbookAllowed: !prevState.isOverbookAllowed, selectedDate: undefined
        }), () => {
            this.getIncludedDates();
            this.getIncludedTimes();
        })
    }

    formSubmit = (values, {setSubmitting}) => {
        const { appointment_type } = this.props.modalProps;

        const data = {};

        if (values.dateTime) {
            data.overbook = this.state.isOverbookAllowed;
            data.dateTime = moment(values.dateTime).format("YYYY-MM-DDTHH:mm:ss");
        }

        if (appointment_type === "TROUBLE_TICKET") {
            this.props.createTroubleTicketAppointment(values.id, data).then(response => {
                setSubmitting(false);

                if (response?.data?.success) {
                    toastr.success(response.data.message, { timeOut: 2000, position: 'top-center' });
                    this.closeModal();
                }

                if (!response.data) {
                    toastr.error(response.response.data.error.message, { timeOut: 2000, position: 'top-center' });
                    return;
                }

                if (!response.data.success) {
                    if (response.data.error) {
                        toastr.error(response.data.error.message, { timeOut: 2000, position: 'top-center' });
                    } else {
                        toastr.error('Unknown error. Please try again later', { timeOut: 2000, position: 'top-center' });
                    }
                }
            })
        }

        else if (appointment_type === "ORDER") {
            this.props.createOrderAppointment(values.id, data).then(response => {
                setSubmitting(false);
                if (response?.data?.success) {
                    toastr.success(response.data.message, { timeOut: 2000, position: 'top-center' });
                    this.closeModal();
                }

                if (!response.data) {
                    toastr.error(response.response.data.error.message, { timeOut: 2000, position: 'top-center' });
                    return;
                }

                if (!response.data.success) {
                    if (response.data.error) {
                        toastr.error(response.data.error.message, { timeOut: 2000, position: 'top-center' });
                    } else {
                        toastr.error('Unknown error. Please try again later', { timeOut: 2000, position: 'top-center' });
                    }
                }
            })
        }
    }

    getAppointments = () => {
        const { technicianAppointments } = this.props;
        const { appointment_type } = this.props.modalProps;

        switch (appointment_type) {
            case "TROUBLE_TICKET":
                return technicianAppointments.troubleTicketAppointments;
            case "ORDER":
                return technicianAppointments.orderAppointments;
        }
    }

    getAppointmentDateTime = () => {
        const appointments = this.getAppointments();

        if (appointments && appointments.length > 0) {
            const appointment = appointments[0];
            const aptDate = appointment.date;
            const formattedDateTime = moment().year(aptDate.year).dayOfYear(aptDate.dayOfYear).format("YYYY-MM-DD") + 'T' + appointment.timeslot.fromTime;

            return moment(formattedDateTime).toDate();
        }

        return "";
    }

    closeModal = () => {
        this.props.hideModal();

        if (this.props.modalProps.onCloseCallback) {
            this.props.modalProps.onCloseCallback();
        }
    };

    canOverbook = (canOverbookOrders, canOverbookTT, appointmentType) => {
        if(canOverbookOrders && appointmentType == "ORDER"){
            return true;
        }
        if(canOverbookTT && appointmentType == "TROUBLE_TICKET"){
            return true;
        }
        return false;
    };

    handleTimeFormat = (time) => {
        let timeSlot = [];
        let className = '';

        if(this.props.orderTimeslots.length) {
            timeSlot = this.props.orderTimeslots.filter(slot => slot.fromTime === moment(time).format("HH:mm").toString());

        } else if(this.props.troubleTicketTimeslots) {
            timeSlot = this.props.troubleTicketTimeslots.filter(slot => slot.fromTime === moment(time).format("HH:mm").toString());
        }

        // Add timeslot "to"
        if (timeSlot.length) {
            className += " react-datepicker__time-list-item--timeslot-to-";
            className += timeSlot[0].toTime.substring(0, 2);
        }

        return className;
    }

    checkTimeslotValidity = () => {
        const { selectedDate, isOverbookAllowed } = this.state;
        /** If overbooking is allowed, we enable appointments to be scheduled in the past */
        return selectedDate < moment() && !isOverbookAllowed;
    }


    render() {

        const {
            isOverbookAllowed,
            selectedDate,
            includedDates,
            includedTimes,
        } = this.state;

        const {
            technicianAppointments,
            appointmentsLoading,
            technicianAvailability,
            availabilityLoading,
            canOverbookOrders,
            canEditOrderAppt,
            modalProps,
            canEditTTAppt,
            canOverbookTT
        } = this.props;

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <Formik
                            enableReinitialize
                            initialValues={{
                                id: modalProps.id,
                                dateTime: selectedDate,
                            }}
                            onSubmit={this.formSubmit}
                            render={({ handleChange, handleSubmit, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-content">

                                        <div className="modal-header">
                                            <h5 className="modal-title">
                                                Manage Appointments
                                            </h5>
                                            <button
                                                type="button"
                                                className="close"
                                                disabled={isSubmitting}
                                                onClick={this.props.hideModal}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>

                                        <div className="modal-body form-horizontal">

                                            {(appointmentsLoading || availabilityLoading)
                                                ?
                                                <Loader/>
                                                :
                                                <>


                                                    {this.canOverbook(canOverbookOrders,canOverbookTT, modalProps.appointment_type) ?
                                                    <div className="form-group">
                                                    <span className="h-check">
                                                        <label>Overbook&nbsp;</label>
                                                        <div className="form-check checkbox-slider checkbox-slider--b-flat">
                                                            <label>
                                                                <input
                                                                    name="overbook"
                                                                    type="checkbox"
                                                                    checked={isOverbookAllowed}
                                                                    onChange={() => this.handleOverbookChange()}
                                                                    disabled={isSubmitting}
                                                                />
                                                                <span>&nbsp;</span>
                                                            </label>
                                                        </div>
                                                    </span>
                                                    </div>
                                                        :
                                                        <div className="form-group"/>
                                                    }

                                                    <div className="form-group form-group-appointment">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={selectedDate ? moment(selectedDate).format(selectedDate.getHours() === 0 ? "MMMM D, YYYY" : "MMMM D, YYYY @ h:00 A") : "Select Appointment Date and Timeslot"}
                                                            disabled
                                                        />
                                                        <button
                                                            type="button"
                                                            className="form-group-appointment-clear"
                                                            onClick={() => this.setState({selectedDate: undefined})}
                                                            disabled={isSubmitting}
                                                        >
                                                            &times;
                                                        </button>
                                                    </div>

                                                    <div className="form-group d-flex justify-content-center">
                                                        <div className="customDatePickerWidth">
                                                            <DatePicker
                                                                inline
                                                                autoFocus
                                                                popperPlacement={'auto'}
                                                                isClearable
                                                                disabledKeyboardNavigation
                                                                showTimeSelect
                                                                shouldCloseOnSelect={false}
                                                                placeholderText={"Select Appointment Date and Timeslot"}
                                                                selected={values.dateTime}
                                                                onChange={(date) => !isSubmitting ? this.handleDateTimeChange(date) : null}
                                                                includeDates={isOverbookAllowed ? null : includedDates || []}
                                                                includeTimes={includedTimes}
                                                                timeIntervals={60}
                                                                minDate={moment().toDate()}
                                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                                timeFormat="haa"
                                                                timeClassName={(time) => this.handleTimeFormat(time)}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                        </div>

                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn"
                                                disabled={isSubmitting}
                                                onClick={this.props.hideModal}
                                            >
                                                Cancel
                                            </button>
                                            {(canEditOrderAppt && modalProps.appointment_type === "ORDER") ||
                                                (canEditTTAppt && modalProps.appointment_type === "TROUBLE_TICKET")
                                                ?
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    disabled={
                                                        isSubmitting ||
                                                        appointmentsLoading ||
                                                        availabilityLoading ||
                                                        (selectedDate && selectedDate.getHours() === 0 || this.checkTimeslotValidity())
                                                    }
                                                >
                                                    Save Appointment
                                                </button>
                                                : null
                                            }
                                        </div>

                                    </div>
                                </form>
                            )}
                        />
                    </div>
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}


const getAppointmentsLoadingSelector = createLoadingSelector(['GET_ORDER_APPOINTMENTS', 'GET_TROUBLE_TICKET_APPOINTMENTS']);
const getAvailabilityLoadingSelector = createLoadingSelector(['GET_ORDER_AVAILABILITY', 'GET_TROUBLE_TICKET_AVAILABILITY']);

const mapStateToProps = (state) => {

    const modalProps = getModalData(state).modalProps;
    const technicianAppointments = getTechnicianAppointment(state);
    const appointmentsLoading = getAppointmentsLoadingSelector(state);
    const availabilityLoading = getAvailabilityLoadingSelector(state);
    const technicianAvailability = getTechnicianAppointment(state).availability;
    const geocodeError = getTechnicianAppointment(state).geocodeError;
    const orderTimeslots = getTimeslots(state).orderTimeslots.slice().reverse();
    const troubleTicketTimeslots = getTimeslots(state).troubleTicketTimeslots.slice().reverse();
    const canEditOrderAppt = getUserPermission(state, 'ORDERS', 'ORDER_EDIT_APPOINTMENT');
    const canOverbookOrders = getUserPermission(state, 'ORDERS', 'ORDER_EDIT_APPOINTMENT_OVERBOOK');
    const canEditTTAppt = getUserPermission(state, 'TROUBLE_TICKETS', 'TROUBLE_TICKET_EDIT_APPOINTMENT');
    const canOverbookTT = getUserPermission(state, 'TROUBLE_TICKETS', 'TROUBLE_TICKET_EDIT_APPOINTMENT_OVERBOOK');



    return {
        modalProps,
        technicianAppointments,
        appointmentsLoading,
        technicianAvailability,
        geocodeError,
        availabilityLoading,
        orderTimeslots,
        troubleTicketTimeslots,
        canEditOrderAppt,
        canOverbookOrders,
        canEditTTAppt,
        canOverbookTT
    };
};

const mapDispatchToProps = {
    hideModal,
    getOrderAvailability,
    getTroubleTicketAvailability,
    getOrderAppointments,
    getTroubleTicketAppointments,
    emptyOrderAppointments,
    emptyTroubleTicketAppointments,
    createOrderAppointment,
    createTroubleTicketAppointment,
    clearOrderAvailability,
    clearTroubleTicketAvailability,
    getOrderTimeslots,
    getTroubleTicketTimeslots
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianAppointmentModal);
